<template>
  <footer class="nve pt-4">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <p>En tjeneste levert av NVE, i samarbeid med Meteorologisk institutt.</p>
          <p>Har du spørsmål om tjenesten, kontakt varsom-abonner@nve.no</p>
          <img src="../assets/NVE_logo_firk_red_grey.png" height="81" width="60" alt />
          <img src="../assets/met-logo.svg" width="178" height="81" alt style="margin-left:50px;" />
        </div>
        <div class="col-lg-1 left-border" style></div>
        <div class="col-lg-7 d-none d-lg-block">
          <p>Har du spørsmål tilknyttet varslene ta kontakt direkte med varslingstjenestene:</p>
          <div class="row">
            <div class="col-md-6">
              <p>
                <b>Flomvarslingen (NVE)</b>
                <br />
                <span>tlf. 404 36 000</span>
                <br />
                <span>(08-21 alle dager, ikke SMS)</span>
                <br />
                <span>flomvarsling@nve.no</span>
              </p>
              <p>
                <b>Jordskredvarslingen (NVE)</b>
                <br />
                <span>tlf. 400 28 777</span>
                <br />
                <span>(08-21 alle dager, ikke SMS)</span>
                <br />
                <span>jordskredvarsling@nve.no</span>
              </p>
            </div>
            <div class="col-md-6">
              <p>
                <b>Snøskredvarslingen (NVE)</b>
                <br />
                <span>tlf. 488 80 100</span>
                <br />
                <span>(07-20 alle dager, ikke SMS)</span>
                <br />
                <span>snoskredvarsling@nve.no</span>
              </p>
              <p>
                <span>
                  <b>Værvarslingen (MET)</b>
                </span>
                <br />
                <span>
                  <a href="https://www.met.no/kontakt-oss">https://www.met.no/kontakt-oss</a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.left-border {
  border-left: 1px solid #d3d8db;
}
span > a {
  font-size: 16px;
}
</style>
